export default "__VITE_ASSET__CS58v7Lx__"